var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66659 14H11.3333C11.6869 14 12.026 13.8595 12.2761 13.6095C12.5261 13.3594 12.6666 13.0203 12.6666 12.6667V6.276C12.6665 6.0992 12.5963 5.92966 12.4713 5.80467L8.86192 2.19533C8.73692 2.0703 8.56738 2.00004 8.39059 2H4.66659C4.31296 2 3.97382 2.14048 3.72378 2.39052C3.47373 2.64057 3.33325 2.97971 3.33325 3.33333V12.6667C3.33325 13.0203 3.47373 13.3594 3.72378 13.6095C3.97382 13.8595 4.31296 14 4.66659 14Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentOutline);
export default __webpack_public_path__ + "static/media/DocumentOutline.3e4cb54d531fa03d90cd90fd91b7495b.svg";
export { ForwardRef as ReactComponent };